import { skipToken, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { Permissions } from '@air/api';
import { type Workspace } from '@air/api/types';
import { callAirApi } from '@air/utils-api';

export const ASSET_PERMISSIONS_KEY = '@plugin-ui/ASSET_PERMISSIONS';

// biome-ignore lint/style/noMagicNumbers: Time calculation - 1 hour in milliseconds
const ONE_HOUR_MS = 60 * 60 * 1000;

export type UseAssetPermissionsParams = {
  workspaceId: Workspace['id'] | undefined;
  assetIds: Array<string | undefined> | undefined;
};

export const getAssetPermissionsKey = (params: { workspaceId: Workspace['id'] | undefined; assetIds: string[] }) => {
  return [ASSET_PERMISSIONS_KEY, params];
};

export const useAssetPermissions = (params: UseAssetPermissionsParams) => {
  const { workspaceId } = params;

  const assetIds = useMemo(
    () => [...new Set((params.assetIds ?? []).filter((id): id is string => !!id))].sort(),
    [params.assetIds],
  );

  return useQuery({
    queryFn:
      workspaceId && assetIds.length > 0
        ? () =>
            callAirApi(() =>
              Permissions.getFromObjects({
                mode: 'all',
                objects: { assetIds },
                workspaceId,
              }),
            )
        : skipToken,
    queryKey: getAssetPermissionsKey({ assetIds, workspaceId }),
    staleTime: ONE_HOUR_MS,
  });
};
